'use client';

import Link from 'next/link';
import { useTranslations } from 'next-intl';

export function NotFoundContent() {
  const t = useTranslations('errors.notFound');
  return (
    <div className="flex flex-col items-center justify-center py-24">
      <div className="mb-4 flex h-20 w-20 items-center justify-center rounded-2xl bg-error/10">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          className="h-10 w-10 text-error"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1.5"
            d="M9.172 16.172a4 4 0 015.656 0M9 10h.01M15 10h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
          />
        </svg>
      </div>
      <h1 className="text-4xl font-bold">404</h1>
      <h2 className="mt-2 text-2xl font-bold">{t('title')}</h2>
      <p className="mb-8 mt-3 max-w-sm text-center text-base text-[var(--color-fg-muted)]">{t('description')}</p>
      <Link href="/dashboard" className="btn btn-primary gap-2">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          className="h-5 w-5"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M10 19l-7-7m0 0l7-7m-7 7h18" />
        </svg>
        {t('backHome')}
      </Link>
    </div>
  );
}
